import { render } from "./SlickItem.vue?vue&type=template&id=9b142dc8"
import script from "./SlickItem.vue?vue&type=script&lang=js"
export * from "./SlickItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__